<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        保存問題
      </template>

      <template v-slot:content>
        <div class="message-area">
          <p class="message">※作成日が赤字のものは旧版の内容です</p>
        </div>
        <v-data-table
          :headers="headers"
          :items="histories"
          :loading="loading"
          loading-text="Loading... Please wait"
          :options.sync="pagination"
          hide-default-footer
          :height="300"
          mobile-breakpoint=10
        >
          <template #[`item.materialName`]="{ item }">
            <v-material-chip :type="item.materialCode">{{ item.materialName }}</v-material-chip>
          </template>
          <template #[`item.createdAt`]="{ item }">
            <span :class="getCreatedAtClass(item)"> {{ item.createdAt }}</span>
          </template>
          <template #[`item.preview`]="{ item }">
            <v-btn small color="secondary" dark @click="confirm(item)">確認(遷移)</v-btn>
          </template>
          <template #[`item.delete`]="{ item }">
              <!-- 削除ボタン -->
              <v-icon class="delete-btn" color="red" dark fab @click.stop="openDeleteConfirmDialog(item)">
                mdi-close-circle
              </v-icon>
          </template>
        </v-data-table>
        <v-pagination v-model="pagination.page" :length="pages" color="secondary" />
      </template>

    </v-base-card>

    <v-confirm-dialog
      ref="confirm"
      title="保存問題 削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />

  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VMaterialChip from '@/components/atoms/MaterialChip'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'

export default {
  components: {
    VBaseCard,
    VMaterialChip,
    VConfirmDialog,
  },
  data () {
    return {
      deletedPrint: {
        id: null,
        storedName: '',
      },
      headers: [
        { text: 'タイトル', align: 'center', value: 'storedName', sortable: false },
        { text: '種別', align: 'center', value: 'materialName', sortable: false },
        { text: '準拠', align: 'center', value: 'publisherName', sortable: false },
        { text: '学年', align: 'center', value: 'gradeName', sortable: false },
        { text: '設問数', align: 'center', value: 'questionNum', sortable: false },
        { text: 'ページ数', align: 'center', value: 'pageNum', sortable: false },
        { text: '作成日', align: 'center', value: 'createdAt' },
        { text: 'プレビュー', align: 'center', value: 'preview', sortable: false },
        { text: '削除', align: 'center', value: 'delete', sortable: false },
      ],
      histories: [],
      loading: false,
      pagination: {
        itemsPerPage: 5
      },
    }
  },
  async mounted() {
    await this.getHistories()

    this.$gtag.pageview({
      page_path: '/saved_prints',
      page_title: "保存問題一覧"
    })
  },
  methods: {
    async getHistories() {
      this.loading = true
      const res = await this.$axios.get('/api/v1/prints?q[stored_eq]=true')
      this.histories = res.data
      this.loading = false
    },
    openDeleteConfirmDialog(print) {
      this.deletedPrint = print
      this.$refs.confirm.open()
    },
    // 保存問題削除API
    async confirmDeletion() {
      const url = `api/v1/prints/${this.deletedPrint.id}`
      await this.$axios.put(url, {print: {stored: false}})
      this.$toasted.global.success({ message: `タイトル：${this.deletedPrint.storedName} を削除しました` })
      this.getHistories()
    },
    async confirm(print) {
      this.$store.commit('conditions/setSavePrintMode', {
        savePrintMode: true
      })

      //✅保存問題の詳細取得（PDFの画像表示）
      const res = await this.$axios('/api/v1/prints/'+ print.id)
      const conditionDetails = Object.keys(print.conditionDetails).map(index => {
        const object = print.conditionDetails[index]
        return object
      })
      this.$store.commit('conditions/setConditionDetails', { conditionDetails: conditionDetails })
      this.$store.commit('conditions/setPrintData', {printData: res.data })

      this.$router.push('/teacher/saved_print')
    },
    getCreatedAtClass(item) {
      if (item.materialName !== '教科書') return ''

      // 作成日が「2025年3月3日10:00」より前なら旧版
      const oldVersionDate = new Date('2025-03-03T10:00:00')
      const createdAt = new Date(item.createdAt)
      return createdAt <= oldVersionDate ? 'old-version' : ''
    },
  },
  computed: {
    deleteMessage() {
      return `タイトル：${this.deletedPrint.storedName} を削除します。よろしいですか。`
    },
    pages() {
      return this.pagination.itemsPerPage ? Math.ceil(this.histories.length / this.pagination.itemsPerPage) : 0
    },
  }
}
</script>

<style lang="stylus" scoped>
.font-bold
  font-weight bold

.chip
  &__status
    &-applied
      background-color #3E90C6 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #c4c4c4
      display inline-block

    &-contracted
      background-color #4caf50 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #337f36
      display inline-block

    &-shipped
      background-color #8e8e8e !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #6d6464
      display inline-block

.message
  font-size 12px

  &-area
    display flex
    justify-content flex-end

.old-version
  color red

</style>
